// extracted by mini-css-extract-plugin
export default {"ItemContainer":"AttributeItem_ItemContainer__8XV-y","Header":"AttributeItem_Header__JjyXy","Body":"AttributeItem_Body__clCgI","PopupIcon":"AttributeItem_PopupIcon__JOPKI"};